import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IepService } from '../../../../student360/iep/iep.service';
import { SpedCardsService } from '../../../sped-home/sped-cards/sped-cards.service';
import { SpedStudentDocumentCardsService } from '../../../student-document-home/sped-student-document-cards/sped-student-document-cards.service';

@Component({
  selector: 'app-indeterminate-progress-bar',
  templateUrl: './indeterminate-progress-bar.component.html',
  styleUrls: ['./indeterminate-progress-bar.component.css']
})
export class IndeterminateProgressBarComponent implements OnInit {
  spEdcollectionId: number;
  studentId: number;
  studentCollectionId: number;
  spEdCollectionToIEPStatusId: number;
  templateVersionId: number; // 0 when Mass content
  siteId: number;
  yearId: number;
  callFromHomePage: boolean;
  studentTemplateVersionIds: string;
  studentHeader: boolean;
  fileAsBlobString: Blob;
  printType: number; // 0 when print student document, 1 when print Blank, 2 when print View only student document.


  constructor(private dialog: MatDialog,
    private dialogPB: MatDialogRef<IndeterminateProgressBarComponent>,
    private spedCardService: SpedCardsService,
    private spedStudentDocumentCradsService: SpedStudentDocumentCardsService,
    private iepService: IepService) { }

  ngOnInit(): void {
    if (this.printType == 0) {
      this.spedCardService.viewContentDocument(this.spEdcollectionId, this.studentId, this.studentCollectionId, this.spEdCollectionToIEPStatusId, this.templateVersionId, 0, this.yearId, this.callFromHomePage, this.studentTemplateVersionIds, this.studentHeader).subscribe(docBase64String => {
        const byteCharacters = atob(docBase64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileAsBlob = new Blob([byteArray], { type: 'application/pdf' });
        this.fileAsBlobString = fileAsBlob;
        this.dialogPB.close('print');
      });
    }
    else if (this.printType == 1) {
      this.spedStudentDocumentCradsService.viewBlankDocument(this.spEdcollectionId).subscribe(docBase64String => {
        const byteCharacters = atob(docBase64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileAsBlob = new Blob([byteArray], { type: 'application/pdf' });
        this.fileAsBlobString = fileAsBlob;
        this.dialogPB.close('print');
      });
    }
    else if (this.printType == 2) {
      this.iepService.viewCollectionDocument(this.spEdcollectionId,
        this.studentId,
        this.studentCollectionId,
        this.spEdCollectionToIEPStatusId,
        this.templateVersionId,
        0,
        this.siteId,
        this.yearId).subscribe(docBase64String => {

          const byteCharacters = atob(docBase64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const fileAsBlob = new Blob([byteArray], { type: 'application/pdf' });
          this.fileAsBlobString = fileAsBlob;
          this.dialogPB.close('print');
        });
    }

  }

  cancelClick() {
    this.dialogPB.close();
  }
}
